import App from '@/App.vue'
import i18n from '@/features/locales/i18n'
import { createSentryPiniaPlugin } from '@sentry/vue'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import { createRouter } from './router/index'

import setupComponents from '@/plugins/components'
import setupDirectives from '@/plugins/directives'
import setupErrorHandling from '@/plugins/errorHandling'
import setupPersistedState from '@/plugins/persistedState'
import setupSvgEvents from '@/plugins/svgEvents'
import setupViewport from '@/plugins/viewport'
import { setConfig } from './utils/config'

const config = await setConfig()

const app = createApp(App)
const pinia = createPinia()
const router = createRouter()

pinia.use(createPersistedState(setupPersistedState()))
pinia.use(
  createSentryPiniaPlugin({
    stateTransformer: (state) => {
      const transformedState = {
        ...state,
        auth: {
          ...state.auth
        },
        branded: null,
        designer: undefined,
        knowledgeBase: undefined,
        sandbox: undefined,
        touch: undefined,
        visualiser: undefined
      }
      return transformedState
    }
  })
)

app.use(setupSvgEvents)
app.use(i18n)
app.use(router)
app.use(pinia)

window.logoutPush = false
window.VITE_APP_INSTALLATION_TYPE = import.meta.env.VITE_APP_INSTALLATION_TYPE

setupDirectives(app)
setupComponents(app)
setupErrorHandling(app, router, config)
setupViewport()

app.mount('#app')
